import type { CourseStatus } from '@openclassrooms/sdk-web';

import getCRUDHooks from '../../utils/services/getCRUDHooks';
import { clientApi } from '../../configuration';

type CourseTableOfContentParams = {
  userId: number;
  courseId: number;
  queryParams: {
    status?: CourseStatus;
  };
};

const { useGet: useUserCourseTableOfContent } = getCRUDHooks({
  entityName: 'userCourseTableOfContent',
  get: ({ userId, courseId, queryParams = {} }: CourseTableOfContentParams) =>
    clientApi
      .getOCClient()
      .helpers.learningActivity.courses.getTableOfContent(userId, courseId, queryParams),
});

export default useUserCourseTableOfContent;
